import React, { Component } from "react";
import BlogItems from './BlogItems'
import { Route, Switch } from 'react-router-dom'
import ArticleDetails from './ArticleDetails'
import BlogInfo from './BlogInfo'
import LatestArticleDetails from './LatestArticleDetails'


export default class Blog extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const blogData = BlogInfo.map(item => item)
    return (
      <React.Fragment>
        
      <Switch>
        <Route exact path="/blog" component={BlogItems} />
        <Route path='/blog/latest' component={LatestArticleDetails}/>
        <Route path={blogData.link} component={ArticleDetails}/>
      </Switch>
    </React.Fragment>
    );
  }
}
